/**
 * Alshallal Pastry Company HR System - Unexcused Absence (department managers)
 *
 * Owner's requirement (2026-11): a dedicated option, for department managers
 * only, to report a team member's absence when no valid excuse or prior notice
 * was given. The server refuses every other role (POST /api/leave/unexcused-absences).
 */
import React from 'react';
import { UserX } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { ReportUnexcusedAbsence } from '@/components/leave/UnexcusedAbsences';

const UnexcusedAbsencePage = () => {
  const { user } = useAuth();
  const { isRTL } = useLanguage();

  return (
    <div className="space-y-6" data-testid="unexcused-absence-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
          <UserX className="h-6 w-6 text-slate-500" />
          {isRTL ? 'غياب بدون عذر' : 'Unexcused Absence'}
        </h1>
        <p className="text-slate-600 mt-1">
          {isRTL ? 'الإبلاغ عن غياب أحد موظفي إدارتك دون عذر أو إبلاغ مسبق' : 'Report a team member absent without a valid excuse or prior notice'}
        </p>
      </div>
      {user?.role === 'manager' ? (
        <ReportUnexcusedAbsence isRTL={isRTL} />
      ) : (
        <p className="text-slate-600" role="alert">
          {isRTL ? 'هذه الصفحة متاحة لمديري الإدارات فقط.' : 'This page is available to department managers only.'}
        </p>
      )}
    </div>
  );
};

export default UnexcusedAbsencePage;
